// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import { Outlet, useLocation } from "react-router-dom";

// const Layout = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [showMobileSidebar, setShowMobileSidebar] = useState(false);

//   // Shared between Header (gear icon) and Sidebar (module icon strip)
//   const [activeModule, setActiveModule] = useState(null);
//   const [mode, setMode] = useState("modules"); // "modules" | "settings"

//   const location = useLocation();
//   const isHomePage = location.pathname.includes("/home");
//   const isHROverviewTabs = location.pathname.includes("/hr/attendance-management");
//   const inviteForm = location.pathname.includes("/invite");
//   const myAccountPage = location.pathname.includes("/my-account");
//   const isOrganizationPage = location.pathname.includes("/my-organization");

//   const toggleSidebar = () => {
//     setShowMobileSidebar(!showMobileSidebar);
//   };
// // bg-gradient-to-b from-red-100 to-white 
//   return (
//     <div className="flex flex-col h-screen bg-[#f9f9fb] overflow-hidden">
//       <Header
//         collapsed={collapsed}
//         toggleSidebar={toggleSidebar}
//         showMobileSidebar={showMobileSidebar}
//         activeModule={activeModule}
//         setActiveModule={setActiveModule}
//         mode={mode}
//         setMode={setMode}
//       />
//       <div className="flex flex-1 overflow-hidden">
//         <Sidebar
//           collapsed={collapsed}
//           setCollapsed={setCollapsed}
//           showMobileSidebar={showMobileSidebar}
//           toggleSidebar={toggleSidebar}
//           activeModule={activeModule}
//           setActiveModule={setActiveModule}
//           mode={mode}
//         />
//         <div
//           id="scrollable-container"
//           className={`overflow-auto flex-1 ${
//             isHomePage || inviteForm || myAccountPage || isOrganizationPage || isHROverviewTabs
//               ? ""
//               : "px-2 py-4 md:px-4"
//           }`}
//         >
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  // Shared between Header (gear icon) and Sidebar (module icon strip)
  const [activeModule, setActiveModule] = useState(null);
  const [mode, setMode] = useState("modules"); // "modules" | "settings"

  const location = useLocation();
  // const isHomePage = location.pathname.includes("/home");
  // const isHROverviewTabs = location.pathname.includes("/hr/attendance-management");
  // const isKraPerformanceTabs = location.pathname.includes("/hr/performance-management");
  // const inviteForm = location.pathname.includes("/invite");
  // const myAccountPage = location.pathname.includes("/my-account");
  // const isOrganizationPage = location.pathname.includes("/my-organization");


  useEffect(() => {
    const isSettingsPath = location.pathname.includes("/settings");
    if (isSettingsPath) {
      setMode("settings");
    } else {
      setMode("modules");
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleSidebar = () => {
    setShowMobileSidebar(!showMobileSidebar);
  };

  return (
    <div className="flex flex-col h-screen bg-[#f9f9fb] overflow-hidden">
      <Header
        collapsed={collapsed}
        toggleSidebar={toggleSidebar}
        showMobileSidebar={showMobileSidebar}
        activeModule={activeModule}
        setActiveModule={setActiveModule}
        mode={mode}
        setMode={setMode}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          showMobileSidebar={showMobileSidebar}
          toggleSidebar={toggleSidebar}
          activeModule={activeModule}
          setActiveModule={setActiveModule}
          mode={mode}
        />
        {/* <div
          id="scrollable-container"
          className={`overflow-auto flex-1 ${
            isHomePage || inviteForm || myAccountPage || isOrganizationPage || isHROverviewTabs || isKraPerformanceTabs
              ? ""
              : "px-2 py-4 md:px-4"
          }
          `}
        > */}
        <div
          id="scrollable-container"
          className={`overflow-auto flex-1 
          `}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;